/// KVKK onay kapısı kararı (mobil `kvkkConsentMissing` ile aynı kural).
/// Rıza yoksa ya da onaylanan sürüm sunucunun güncel sürümünden farklıysa
/// kullanıcıdan yeniden rıza istenir. Anahtarlar yanıtta hiç yoksa (eski
/// backend / eski önbellek) karar verilemez → kapı açılmaz.
export interface KvkkConsentFields {
  role: string;
  kvkkConsentAt?: string | null;
  kvkkConsentVersion?: string | null;
  kvkkCurrentVersion?: string | null;
}

export function kvkkConsentMissing(user: KvkkConsentFields | null | undefined): boolean {
  if (!user) return false;
  if (user.role === 'super_admin') return false;
  // Anahtar yok (undefined) → eski backend; rızasızsa sunucu null gönderir.
  if (user.kvkkConsentAt === undefined) return false;
  if (user.kvkkConsentAt === null) return true;
  const current = user.kvkkCurrentVersion;
  return !!current && (user.kvkkConsentVersion ?? null) !== current;
}
